<template>
  <div class="view-item">
    <span
      v-if="[fieldType.DATE, fieldType.DATETIME].includes(field.type)"
    >
      {{ data.extra[field.key] | convertDateTime(field.format) }}
    </span>
    <span v-else-if="[fieldType.SELECT].includes(field.type) && field.options.type">
      {{ data.extra[field.key] | categoryName(allCategories) }}
    </span>
    <span v-else-if="[fieldType.MODULE].includes(field.type)">
      {{ data.extra[field.key] | moduleName(configModules) }}
    </span>
    <ItemFiles
      v-else-if="
        [
          fieldType.FILE_IMAGES,
          fieldType.FILE_VIDEOS,
          fieldType.FILE_AUDIOS,
          fieldType.FILE_OTHERS,
        ].includes(field.type) && filePermission.READ
      "
      :form="data.extra"
      :field="field"
      :disabled="true"
    />
    <ItemLinkYoutube
      v-else-if="[fieldType.LINK_YOUTUBE].includes(field.type)"
      :form="data.extra"
      :field="field"
      :disabled="true"
    />
    <ItemLink3ds
      v-else-if="[fieldType.LINK_3DS].includes(field.type)"
      :form="data.extra"
      :field="field"
      :disabled="true"
    />
    <el-tooltip
      v-else
      :content="String(data.extra[field.key])"
      popper-class="custom-tooltip"
    >
      <span
        class="text-limited text-limited__2"
      >
        {{ data.extra[field.key] }}
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/config/constants";
import ItemFiles from "@/components/items/Files";
import ItemLink3ds from "@/components/items/Link3ds";
import ItemLinkYoutube from "@/components/items/LinkYoutube";

import { filePer } from "@/utils/permission";

export default {
  name: "ViewItem",
  components: {
    ItemFiles,
    ItemLink3ds,
    ItemLinkYoutube,
  },
  props: {
    data: Object,
    field: Object,
    configModules: Array
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
      filePermission: filePer(),
    };
  },
  computed: {
    ...mapGetters("category", ["allCategories"]),
  },
  methods: {
  },
};
</script>

<style lang="scss">
  .custom-tooltip {
    max-width: 300px;
    line-height: 1.5;
    white-space: normal;
    font-size: 16px;
  }
</style>
